/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackCreateCompletionFeedback } from "../../funcs/llmFeedbackCreateCompletionFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateCompletionFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackCreateCompletionFeedback: ToolDefinition<
  typeof args
> = {
  name: "llm-feedback-create-completion-feedback",
  description: `Submit feedback for chat completion

Submit user feedback for a specific chat completion to track satisfaction and model performance. Each completion can only receive feedback once.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFeedbackCreateCompletionFeedback(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
